module.exports = __webpack_public_path__ + "img/logo_Q_Plugin.997470dd.svg";